import { render, staticRenderFns } from "./ProformaRentalForm.vue?vue&type=template&id=f5a1c2b2&scoped=true"
import script from "./ProformaRentalForm.vue?vue&type=script&lang=js"
export * from "./ProformaRentalForm.vue?vue&type=script&lang=js"
import style0 from "./ProformaRentalForm.vue?vue&type=style&index=0&id=f5a1c2b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5a1c2b2",
  null
  
)

export default component.exports